<template>
  <div
    class="flex-grow-1 align-items-center justify-content-center"
    align="center"
  >
    <b-container>
      <div class="w-100 mt-1">
        <h5 class="title-branch text-center">
          {{ i18n.t('choice-filial', getLanguage) }}
        </h5>
        <BranchOfficeCard
          :organization="getWidgetSettings.parent_org ? getWidgetSettings.parent_org : getWidgetSettings"
          @setBranch="setChoiceBranch"
        />
        <BranchOfficeCard
          v-for="(org, i) in (getWidgetSettings.parent_org ? getWidgetSettings.parent_org.belong_to_parent_org : getWidgetSettings.belong_to_parent_org )"
          :key="i"
          :organization="org"
          @setBranch="setChoiceBranch"
        />
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BContainer } from 'bootstrap-vue'
import i18n from '@/libs/i18n'
import BranchOfficeCard from '@/components/branchOffices/BranchOfficeCard.vue'

export default {
  name: 'WidgetBranchOffices',
  components: {
    BContainer,
    BranchOfficeCard,
  },
  data() {
    return {
      i18n,
    }
  },
  computed: mapGetters(['getWidgetSettings', 'getLanguage']),
  methods: {
    setChoiceBranch(branch) {
      this.$emit('setBranch', branch)
    },
  },
}
</script>

<style scoped>

</style>
